document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".wwa-item-video").forEach((videocontainer) => {
    const videoPopup = videocontainer.querySelector(".wwa-videopopup");
    const videoBtn = videocontainer.querySelector(".wwa-videobtn");
    const closeBtn = videocontainer.querySelector(".wwa-videoclosebtn");
    const overlay = videocontainer.querySelector(".videopopup-overlay");
    const videoContainers = videocontainer.querySelector(".video-wp"); // Use the correct container inside each item
    const video = videoContainers ? videoContainers.querySelector("video") : null;
    const iframe = videoContainers ? videoContainers.querySelector("iframe") : null;
    
    function openPopup() {
      videoPopup.classList.add("active");
      
      if (video) {
        video.play();
      } else if (iframe) {
        // Autoplay YouTube iframe
        let src = iframe.getAttribute("src");
        if (!src.includes("autoplay=1")) {
          iframe.setAttribute("src", src + (src.includes("?") ? "&" : "?") + "autoplay=0");
        }
      }
    }
    
    function closePopup() {
      videoPopup.classList.remove("active");

      if (video) {
        video.pause();
        video.currentTime = 0;
      } else if (iframe) {
        // Stop YouTube iframe by resetting src
        let src = iframe.getAttribute("src");
        iframe.setAttribute("src", ""); // Clear src to stop video
        iframe.setAttribute("src", src + (src.includes("?") ? "&" : "?") + "autoplay=0"); // Restore src
      }
    }

    videoBtn.addEventListener("click", openPopup);
    closeBtn.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);
  });

  document.querySelectorAll(".wwa-video-mute-unmutebtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (video) {
        video.muted = !video.muted;
        this.classList.toggle("muted");
      }
    });
  });
  document.querySelectorAll(".wwa-video-pause-playbtn").forEach((button) => {
    button.addEventListener("click", function () {
      const videoWrapper = this.closest(".video-wp");
      if (!videoWrapper) return;

      const video = videoWrapper.querySelector("video");
      if (video) {
        if (video.paused) {
          video.play();
          this.classList.add("playing");
        } else {
          video.pause();
          this.classList.remove("playing");
        }
      }
    });
  });

  const grids = document.querySelectorAll(".cf-grid");
  grids.forEach((grid) => {
      const triggers = grid.querySelectorAll(".cf-trigger");
      triggers.forEach((trigger) => {
          trigger.addEventListener("click", function () {
              const content = this.nextElementSibling;
              const isOpen = content.classList.contains("open");
              grid.querySelectorAll(".cf-trigger").forEach((t) => t.classList.remove("open"));
              grid.querySelectorAll(".cf-content").forEach((c) => {
                  c.style.maxHeight = "0";
                  c.classList.remove("open");
              });
              if (!isOpen) {
                  this.classList.add("open");
                  content.classList.add("open");
                  content.style.maxHeight = content.scrollHeight + "px";
              }
          });
      });
  });

  const chekTemplate = document.body.dataset.template;
  document.querySelectorAll(".custom-dropdown").forEach((dropdown) => {
    const idInput = dropdown.querySelector('[name="id"]');
    const button = dropdown.querySelector(".custom-dropdown-btn");
    const content = dropdown.querySelector(".custom-dropdown-content");
    const items = dropdown.querySelectorAll(".custom-dropdown-content li");
    let productContainer;

    if (chekTemplate === "product") {
      productContainer = dropdown.closest(".product__info-container");
    }

    button.addEventListener("click", (event) => {
      event.stopPropagation();
      document
        .querySelectorAll(".custom-dropdown-content.show")
        .forEach((drop) => {
          if (drop !== content) drop.classList.remove("show");
        });
      content.classList.toggle("show");
    });

    items.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        if (idInput) idInput.value = item.dataset.varid;

        if (chekTemplate === "product" && productContainer) {
          ["option1", "option2", "option3"].forEach((opt) => {
            const value = item.dataset[opt];
            if (value) {
              const optionEvent = productContainer.querySelector(
                `[data-${opt}] [data-${opt}="${value}"]`
              );
              if (optionEvent) optionEvent.click();
            }
          });
        }

        button.innerHTML = item.innerHTML;
        content.classList.remove("show");
      });
    });
  });

  document.addEventListener("click", () => {
    document
      .querySelectorAll(".custom-card .custom-dropdown-content.show")
      .forEach((drop) => drop.classList.remove("show"));
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product_banner_highlights-main').forEach((highlights) => {
    const buttons = highlights.querySelectorAll('.pbh-btn');
    const images = highlights.querySelectorAll('.pbh-img-wp');
    let currentIndex = 0;
    let interval;

    const activateButton = (index) => {
      buttons.forEach((btn, i) => btn.classList.toggle('active', i === index));
      images.forEach((img, i) => img.classList.toggle('active', i === index));
    };

    const startRotation = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        currentIndex = (currentIndex + 1) % buttons.length;
        activateButton(currentIndex);
      }, 3000);
    };

    buttons.forEach((button, index) => {
      button.addEventListener('mouseenter', () => {
        clearInterval(interval);
        currentIndex = index;
        activateButton(currentIndex);
      });
      button.addEventListener('mouseleave', startRotation);
    });

    activateButton(currentIndex);
    startRotation();
  });
});


let productMedia;
const initFlickity = () => {
  productMedia = new Flickity(".product__media-list", {
    freeScroll: false,
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true
  });
};
initFlickity();

function handleDropdownClick() {
  document.querySelectorAll(".custom-dropdown-content").forEach((content) => {
    content.classList.remove("show");
  });
}
// window.addEventListener("click", handleDropdownClick);
